import { Result } from "neverthrow";
import {
  serializableDecorator,
  SerializationError,
  Serialized,
} from "../../shared/utils/serialization";
import { NumberUnit } from "./NumberUnit";

@serializableDecorator<KiloWattHours>()
export class KiloWattHours extends NumberUnit {
  static serialize(unit: KiloWattHours): Result<Serialized, SerializationError> {
    return super._serialize(unit, KiloWattHours);
  }

  static deserialize(serialized: Serialized): Result<KiloWattHours, SerializationError> {
    return super._deserialize(serialized, KiloWattHours);
  }
}